module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Please wait while we activate your profile")])], 1) : (!_vm.error) ? _c('div', [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": "Congratulations, you're all done!"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "check-ticket--right"
  }, [_c('div', {
    staticClass: "movie-details"
  }, [_c('div', {
    staticClass: "confirmation-error"
  }, [_c('p', [_vm._v("Activation completed successfully.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "router": "",
      "to": "/user/profile"
    }
  }, [_vm._v("\n                                        Dashboard\n                                    ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "tertiary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("\n                                        Take me home\n                                    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.related_movies.length > 0) ? _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "movies": _vm.related_movies,
      "label": "Movies we think you'll like"
    }
  }) : _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "movies": _vm.movies,
      "label": "Recommended Movies"
    }
  })], 1)])], 1)])], 1)], 1) : _c('div', [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket"
  }, [_c('sk-title-heading', {
    attrs: {
      "h2": "",
      "label": "Oops! Something went wrong..."
    }
  }), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs10": "",
      "sm10": ""
    }
  }, [_c('div', {
    staticClass: "check-ticket--right"
  }, [_c('div', {
    staticClass: "movie-details"
  }, [(_vm.error != undefined) ? [_c('div', {
    staticClass: "confirmation-error"
  }, [_vm._v("\n                                                    We were unable to activate your account, please try again later.\n                                                ")])] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resendActivation()
      }
    }
  }, [_vm._v("\n                                                Resend Activation Code\n                                            ")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "tertiary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("\n                                                Take Me Home\n                                            ")])], 2)])])], 1)], 1)])], 1)], 1)])], 1), _vm._v(" "), _c('sk-dialog', {
    staticClass: "video",
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.activationDialog),
      callback: function($$v) {
        _vm.activationDialog = $$v
      },
      expression: "activationDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activationDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activationDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Activation Code Sent")]), _vm._v(" "), _c('p', [_vm._v("Please check your mail in order to activate your account.")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "router": "",
      "to": "/"
    }
  }, [_vm._v("Show me home")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0100ab39","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/user/activate.vue
// module id = 555
// module chunks = 0